"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
function Radio(_a) {
    var value = _a.value, _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, label = _a.label;
    return (0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { disabled: disabled, value: value, control: (0, jsx_runtime_1.jsx)(material_1.Radio, {}), label: label, className: "twap-radio ".concat(className) });
}
exports.default = Radio;
